import React, {useMemo} from "react"
import { Box, Stack } from "@mui/material"
import {Pie, PieChart} from "recharts";
import Typography from "@mui/material/Typography";
import SquareIcon from '@mui/icons-material/Square';

const statusIndex = {
  COMPLIANT: 0,
  NOT_COMPLIANT: 1,
  NONE: 2
}
const getDefaultConfig = () => ([
  { name: "Compliant", value: 0, fill: "#28be5f" },
  { name: "Not Compliant", value: 0, fill: "#e74344" },
  { name: "None", value: 0, fill: "#6b6666" },
])
const noData = [
  { name: "No Data", value: 1, fill: "darkgray" },
]

export default function VendorCompliancePieChart({ client, clientVendors = [] }) {

  const vendorLabel = client?.vendorLabel || "Subcontractor"

  const data = useMemo(() => {
    if(clientVendors?.length) {
      const toReturn = getDefaultConfig()
      clientVendors.forEach(clientVendor => {
        const categoryIndex = statusIndex[clientVendor.status] ?? statusIndex.NONE
        toReturn[categoryIndex].value = toReturn[categoryIndex].value + 1
      })
      return toReturn
    }
    return noData
  }, [clientVendors])

  return (
    <Box padding={2}>
      <Typography variant="h4" sx={{mb:1}}>
        {vendorLabel} Compliance Rate
      </Typography>
      <Typography variant="subtitle1" fontSize={"1.5rem"} color={"gray"}>
        Percentage of compliant {vendorLabel}s
      </Typography>
      <PieChart width={300} height={300} style={{marginLeft: "auto", marginRight: "auto"}}>
        <text x={155} y={150} textAnchor="middle" dominantBaseline="middle" style={{fontSize: "45px"}}>
          { clientVendors?.length
            ? Math.floor((data[0].value/clientVendors.length) * 100)
            : "0"
          }%
        </text>
        <text x={155} y={180} textAnchor="middle" dominantBaseline="middle" style={{fill: "gray"}}>Compliant</text>
        <Pie
          data={data}
          cx={150}
          cy={150}
          innerRadius={60}
          outerRadius={80}
          dataKey="value"
        />
      </PieChart>
      <Stack>
        {data.map(status => (
          <Stack direction="row">
            <SquareIcon sx={{color: status.fill}}/>
            <Box flexGrow={1} paddingLeft={1}>{status.name}</Box>
            <Box>{ clientVendors?.length ? status.value : 0} documents</Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
